import { render } from "./AtencionesPage.vue?vue&type=template&id=d0cb925e&scoped=true"
import script from "./AtencionesPage.vue?vue&type=script&lang=js"
export * from "./AtencionesPage.vue?vue&type=script&lang=js"

import "./AtencionesPage.vue?vue&type=style&index=0&id=d0cb925e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0cb925e"]])

export default __exports__